import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../main/main.styles';
import { mixinRobotoBold, mixinRobotoMedium, mixinRobotoRegular } from '../../../styles';
import Chevron from '../../../assets/chevron.svg';

export const ExecutionCardStyles = css`
  ${MainStyles}

  :host {
    display: contents;
  }

  .header h2 {
    color: var(--white-smoke);
    ${mixinRobotoBold}
  }

  .execution-card {
    width: 1088px;
    height: auto;
    flex-direction: row;
    padding: 0;
    margin-bottom: 16px;
    background-color: var(--side-menu-bg);
  }

  zero-tabs.rfq-tabs,
  fast-accordion {
    width: 553px;
  }

  .rfq-tabs zero-tab {
    width: 50%;
    margin: 0;
    background: transparent;
    border: none;
    box-shadow: none;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.3);
    ${mixinRobotoMedium()}
  }

  .rfq-tabs zero-tab[aria-selected='true'] {
    color: var(--primary-color);
    border-bottom: 1px solid var(--primary-color);
  }

  .rfq-tabs zero-tab[aria-selected='false']:hover {
    color: #fff;
  }

  .parent-tab zero-tab .rowCount {
    display: inline-block;
    width: 18px;
    height: 18px;
    background-color: rgba(249, 100, 77, 0.3);
    color: var(--white);
    margin-left: 8px;
    border-radius: 4px;
    text-align: center;
  }

  .rfq-tabs zero-tab .rowCount {
    display: inline-block;
    width: 18px;
    height: 18px;
    background-color: rgba(249, 100, 77, 0.3);
    color: var(--white);
    margin-left: 8px;
    border-radius: 4px;
    text-align: center;
  }

  fast-accordion-item::part(heading) {
    height: 42px;
    border: 1px solid #2e3339;
    border-radius: 6px;
    background-color: #1a1b1f;
  }

  fast-accordion-item::part(expanded-icon),
  fast-accordion-item::part(collapsed-icon) {
    align-items: center;
    justify-content: center;
    height: 30px;
    width: 30px;
    background-color: #25272c;
    fill: #879ba6;
    border-radius: 2px;
  }

  fast-accordion-item.expanded .heading {
    color: #a9ff78;
  }

  .negotiation {
    width: 100%;
    padding: 14px 50px 14px 15px;
    border-bottom: 1px solid var(--border-1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
  }

  .negotiation:hover {
    background-color: rgba(255, 255, 255, 0.03);
  }

  .negotiation.expired {
    padding-right: 47px;
  }

  .negotiation::after {
    content: '';
    position: absolute;
    right: 15px;
    top: 16px;
    background: url(${Chevron}) no-repeat center;
    height: 24px;
    width: 24px;
    border-radius: 4px;
    background-size: 6px 12px;
    background-color: rgba(135, 155, 166, 0.15);
  }

  .negotiation.selected {
    background-color: rgba(255, 255, 255, 0.07);
  }

  .negotiation span.ticker {
    font-size: 14px;
    line-height: 25px;
    color: var(--nest-level-tab-font);
    ${mixinRobotoMedium()}
  }

  .negotiation.selected span.ticker {
    color: var(--primary-color);
  }

  .negotiation span.details {
    font-size: 12px;
    color: var(--gray-lighter);
    ${mixinRobotoMedium()}
  }

  .negotiation span.details .bin {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    margin-left: 15px;
    background-color: rgba(135, 155, 166, 0.15);
    border-radius: 4px;
  }

  .negotiation span.details .bin:hover path {
    fill: white;
  }

  .negotiation.selected span.details {
    color: var(--white);
  }

  .negotiation span.status {
    border-width: 1px;
    border-style: solid;
    border-radius: 25px;
    width: 110px;
    line-height: 22px;
    color: var(--cascade-silver);
    text-align: center;
    ${mixinRobotoRegular}
  }

  .negotiation span.status.red {
    border-color: var(--error);
    background-color: rgba(248, 100, 77, 0.19);
  }

  .negotiation span.status.yellow {
    border-color: rgba(255, 182, 96, 1);
    background-color: rgba(255, 182, 96, 0.19);
  }

  .negotiation span.status.green {
    border-color: var(--completed);
    background-color: rgba(122, 204, 121, 0.19);
  }

  .not-visualized {
    width: 15px;
    height: 15px;
    background-color: var(--completed);
    border-radius: 50%;
  }

  fast-accordion-item::part(region) {
    padding: 0;
  }

  fast-accordion-item::part(button) {
    padding-left: 15px;
  }

  .ticker {
    white-space: nowrap;
  }
  .details {
    display: block;
    width: 50%;
  }
`;
